import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Home from "@/views/Home.vue";

const routes: Array<RouteRecordRaw> = [
	{ path: "/:articleId/:token", props: true, name: "Home", component: Home },
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

export default router;
